/* fstv-stage-shared.js — the ONE behavioural script for the Stages d'été 2026 Standard product
   pages. Loaded once per page via <script defer> from snippets/fstv-stage-shared.liquid (rendered
   by every fstv-stage-* section). Each section emits an identical <script src> tag; the browser
   fetches the file once, but every tag still EXECUTES, so the __fstvStageInit guard makes the body
   run exactly once. `defer` + the readyState check guarantee the DOM is fully parsed before the
   observers attach, so #acheter / .closing exist by then (fixes the spine's latent timing bug). */
(function () {
  if (window.__fstvStageInit) return;
  window.__fstvStageInit = true;

  function init() {
    // SCROLL-REVEAL (progressive enhancement): the hidden base state is only armed once JS runs,
    // then revealed on intersection. No JS / reduced-motion => content is already visible (base CSS).
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      document.querySelectorAll('.fstv-stage [data-scroll-anim]').forEach(function (el) {
        el.classList.add('fss-anim');   // arm the hidden base state only when JS is present
        io.observe(el);
      });
    }

    // BACK STRIP — pin the « retour au hub » bar under the theme's sticky header. The header
    // compresses on scroll, so its bottom edge moves: track it on scroll/resize (rAF-coalesced)
    // plus the theme's own headerStickyChange event. Progressive: without JS the strip stays a
    // normal in-flow bar at the top of the hero (is-fixed is only armed here).
    var strip = document.getElementById('fss-back-strip');
    if (strip) {
      var headerEl = document.querySelector('[data-section-type="header"]') || document.querySelector('.header-section');
      var placeQueued = false;
      var place = function () {
        placeQueued = false;
        var top = headerEl ? Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom)) : 0;
        strip.style.top = top + 'px';
      };
      var queuePlace = function () {
        if (placeQueued) return;
        placeQueued = true;
        window.requestAnimationFrame(place);
      };
      strip.classList.add('is-fixed');
      place();
      window.addEventListener('scroll', queuePlace, { passive: true });
      window.addEventListener('resize', queuePlace);
      document.addEventListener('headerStickyChange', queuePlace);
    }

    // STICKY CTA — visible once the buy box (#acheter) has scrolled past, hidden while the buy box
    // OR the closing band (.closing) is on screen. Stable selectors across section files (#19).
    var bb = document.getElementById('acheter');
    var bar = document.getElementById('fss-sticky-cta');
    var closing = document.querySelector('.fstv-stage .closing');
    if (bb && bar) {
      var bbPassed = false, closingOn = false;
      function syncBar() {
        var on = bbPassed && !closingOn;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bbPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
        syncBar();
      }, { threshold: 0 }).observe(bb);
      if (closing) {
        new IntersectionObserver(function (entries) {
          closingOn = entries[0].isIntersecting;
          syncBar();
        }, { threshold: 0.25 }).observe(closing);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
